/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

import * as React from 'react';
import { IConnellyBackgroundVideoViewProps } from './connelly-background-video';

//@ts-ignore
import YoutubeBackground from 'react-youtube-background';

export default (props: IConnellyBackgroundVideoViewProps) => {

    const { 
        videoId,
        overlay,
        className,
        title

    } = props;

    return (
        <div className='bgvideo'>
            <div className='cn-title text-center flex-vertical'>{title}</div>
            <YoutubeBackground
                videoId={videoId}
                overlay={overlay}
                className={className}
            ></YoutubeBackground>
        </div>
    );
};
